module.exports = __webpack_public_path__ + "media/images/talent/lp/feature01-c5ad3c3cf41320f5c2c96cdfc57a9539.png";